/* eslint-disable react-hooks/exhaustive-deps */
import { useAuthContext } from "@/context/auth/AuthContext";
import LoadAndDisplay from "@/context/LoadAndDisplay";
import axios from "axios";
import Image from "next/image";
import { handleImage, encodeForURL } from "@/context/utilities";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";

const LastWatched = () => {
  const router = useRouter();
  const [history, setHistory] = useState([]);
  const { user } = useAuthContext();

  const fetchHistory = async () => {
    if (user) {
      try {
        const response = await axios.get(`/api/history?userId=${user.email}`);

        if (response.status === 200) {
          setHistory(response.data.data);
        } else {
          console.error("Error fetching data");
        }
      } catch (err) {
        console.error("Fetch data error:", err);
      }
    }
  };
  useEffect(() => {
    fetchHistory();
  }, [user]);

  return (
    <div>
      <div className="col-12">
        <div className="rbt-calendar-content bg-color-white rbt-shadow-box">
          <div className="section-title">
            <h4 onClick={fetchHistory} className="rbt-title-style-3">
              Last Watched
            </h4>
          </div>
          <div className="rbt-dashboard-table table-responsive  mt--30">
            <table className="rbt-table table table-borderless">
              <thead>
                <tr>
                  <th>Subtopic Name</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <LoadAndDisplay isLoading={false}>
                  <tr key={`course-enrolled-${history?.video?._id}`}>
                    <th>
                      <span className="h6 mb--5">
                        {history?.video?.displayName}
                      </span>
                    </th>
                    <td>
                      <div className="rbt-button-group justify-content-end">
                        <Link
                          className="rbt-btn btn-xs bg-primary-opacity radius-round"
                          href={
                            history?.video?.displayName
                              ? `/student/library/${
                                  history?.video?.subject?.$id
                                }/${history?.video?.topic?.$id}/${encodeForURL(
                                  history?.video?.displayName
                                )}-${history?.video?._id}/watch`
                              : "#"
                          }
                          title="Select sub-topic"
                        >
                          <i className="feather-arrow-right pl--0"></i>
                        </Link>
                      </div>
                    </td>
                  </tr>
                </LoadAndDisplay>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LastWatched;
